import ReactDOM from 'react-dom';

import firebaseui from 'firebaseui';
import firebase from 'firebase';

import authPageTemplate from './Auth.template.html.js';

// FirebaseUI config.
var uiConfig = {
  signInOptions: [
    // Leave the lines as is for the providers you want to offer your users.
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    firebase.auth.EmailAuthProvider.PROVIDER_ID
  ],
  // Terms of service url.
  tosUrl: 'http://www.owenmead.com/',
  callbacks: {
    signInSuccess: function(currentUser, credential, redirectUrl) {
      // Don't redirect
      return false;
    }
  }
};

var authUI = new firebaseui.auth.AuthUI(firebase.auth());

export default {
  getUser: () => {
    var u = firebase.auth().currentUser;
    return {
      name: u.displayName,
      uid: u.uid,
      photoURL: u.photoURL
    }
  },
  wrapUI: (rootEl, renderFn) => {
    firebase.auth().onAuthStateChanged(function(user) {
      // Clear anything that existed before
      ReactDOM.unmountComponentAtNode(rootEl);
      rootEl.innerHTML = '';

      if (user) {
        renderFn();
      } else {
        rootEl.innerHTML = authPageTemplate;
        authUI.start(
          rootEl.querySelector('#authRoot'),
          uiConfig
        );
      }
    });
  },
  signOut: () => {
    firebase.auth().signOut();
  }
}



// WEBPACK FOOTER //
// ./src/Database/Auth.js